export default __webpack_public_path__ + "static/media/kaminfeuer_web-sm@1x.28f34128.webp";